module.exports = __webpack_public_path__ + "img/xbsv_teranode.3942f08.png";